<template>
    <Modal id="queueRequestModal" class="modal-container ">
        <template #header>
            <h5 style="color: #212529;">Detalle Petición</h5>
        </template>
        <template #body>
            <div class="row " style="max-height: 300px; overflow-y: auto;">
                <div class="col-12">
                    <ul id="queueTab" class="nav nav-tabs" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button id="request-tab" class="nav-link active" data-bs-toggle="tab"
                                data-bs-target="#queueRequest" type="button" role="tab" aria-controls="home"
                                aria-selected="true">Petición</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button id="response-tab" class="nav-link" data-bs-toggle="tab"
                                data-bs-target="#queueResponse" type="button" role="tab" aria-controls="profile"
                                aria-selected="false">Respuesta</button>
                        </li>
                    </ul>
                    <div id="queueTabContent" class="tab-content m-4 ">
                        <div id="queueRequest" class="tab-pane fade show active" role="tabpanel"
                            aria-labelledby="request-tab">
                            {{ localValue.request }}
                        </div>
                        <div id="queueResponse" class="tab-pane fade " role="tabpanel" aria-labelledby="response-tab">
                            {{ localValue.response }}</div>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <button id="close" type="button" class="btn  btn-outline-primary" data-bs-dismiss="modal">Cerrar</button>
        </template>
    </Modal>
</template>

<script>
import Modal from '@/components/ModalHotakauth.vue';
export default {
    name: "QueueDetails",
    components: {
        Modal
    },
    props: {
        queueInfo: {
            type: Object,
            default: () => ({
                request: '',
                response: ''
            }),
        },
    },
    
    data() {
        return {
            localValue: {request:'', response:''},
        }
    },
    watch: {
        queueInfo(newValue) {
            this.localValue= {...newValue};
            if(typeof this.localValue.request==='object'){
                this.localValue.request = JSON.stringify(
                    this.localValue.request,
                    null,
                    6
                );
            }
            if(this.isJson(this.localValue.response)){
                this.localValue.request = JSON.stringify(
                    JSON.parse(this.localValue.response),
                    null,
                    3
                );
                
            }
        },
    },
    mounted () {
        this.localValue= this.queueInfo;
    },
    methods: {
        hideModal() {
            document.getElementById('close').click();
        },
        isJson(val) {
            try {
                JSON.parse(val);
            } catch (e) {
                return false;
            }
            return true;
        }
    },

};
</script>
<style scoped>
.modal-container {
    height: 500px;
    white-space: pre-wrap;
}

</style>

